import Reveal from "@/components/site/Reveal";

export default function PageHero({ eyebrow, title, intro, image, children }) {
  return (
    <header className="container-x pb-16 pt-36 sm:pb-20 sm:pt-44">
      <Reveal>
        <div className={image ? "grid items-center gap-12 lg:grid-cols-2 lg:gap-16" : ""}>
          <div>
            {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
            <h1 className="max-w-3xl text-4xl font-medium leading-[1.12] tracking-tight sm:text-5xl lg:text-6xl">
              {title}
            </h1>
            {intro && (
              <p className="mt-7 max-w-2xl text-lg leading-relaxed text-ink/75">{intro}</p>
            )}
          </div>
          {image && (
            <img
              src={image.src}
              alt={image.alt}
              loading="lazy"
              className="aspect-[4/3] w-full rounded-2xl object-cover"
            />
          )}
        </div>
        {children}
        <div className="mt-16 h-px w-full bg-line" aria-hidden="true" />
      </Reveal>
    </header>
  );
}
